import { firebaseFS } from "./../Firebase/FirebaseApp";
import { __Colecciones } from "./../environment";

export const dispatchController = (type, typeError, dispatch, bodyJson) => {
  const resultado = bodyJson?.Resultado || "N";
  const mensaje = bodyJson?.Mensaje || "";
  const datos = bodyJson?.Datos || [];

  switch (resultado.toUpperCase()) {
    case "E":
      dispatch({
        type: typeError,
        Mensaje: mensaje,
      });
      break;

    default:
      dispatch({
        type: type,
        payload: datos,
        Resultado: resultado,
        Mensaje: mensaje,
      });
      break;
  }
};

export const buscarCliente = (id) => {
  return new Promise(async (resolve) => {
    let respuesta = {
      Resultado: "E",
      Mensaje: "",
      Cliente: {},
    };

    try {
      const consultaCliente = await firebaseFS
        .collection(__Colecciones.Cliente)
        .doc(id);

      await consultaCliente
        .get()
        .then((doc) => {
          if (doc.exists) {
            respuesta = {
              ...respuesta,
              Resultado: "S",
              Cliente: {
                id: doc.id,
                datos: doc.data(),
              },
            };
          } else {
            respuesta = {
              ...respuesta,
              Resultado: "E",
              Mensaje: "Usuario no encontrado",
            };
          }
          resolve(respuesta);
        })
        .catch((error) => {
          respuesta = {
            ...respuesta,
            Resultado: "E",
            Mensaje: error.message,
          };
          resolve(respuesta);
        });
    } catch (error) {
      respuesta = {
        ...respuesta,
        Resultado: "E",
        Mensaje: error.message,
      };
      resolve(respuesta);
    }
  });
};

export const buscarPedidoActual = (id) => {
  return new Promise(async (resolve) => {
    let respuesta = {
      Resultado: "E",
      Mensaje: "",
      Pedido: {},
    };

    let pedidoActual = {};

    try {
      const consultaPedido = await firebaseFS
        .collection(__Colecciones.Cotizacion)
        .where("Estatus", "==", "ACTIVO")
        .where("Cliente.id", "==", id)
        .limit(1);

      await consultaPedido
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            pedidoActual = {
              ...pedidoActual,
              id: doc.id,
              datos: doc.data(),
            };
          });

          respuesta = {
            ...respuesta,
            Resultado: "S",
            Mensaje: "",
            Pedido: pedidoActual,
          };

          resolve(respuesta);
        })
        .catch((error) => {
          respuesta = {
            ...respuesta,
            Resultado: "E",
            Mensaje: error.message,
          };
          resolve(respuesta);
        });
    } catch (error) {
      respuesta = {
        ...respuesta,
        Resultado: "E",
        Mensaje: error.message,
      };
      resolve(respuesta);
    }
  });
};

export const buscarClienteYPedidoActual = (id) => {
  return new Promise(async (resolve) => {
    let respuesta = {
      Resultado: "E",
      Mensaje: "",
      Cliente: {},
    };

    try {
      const respuestaCliente = await buscarCliente(id);
      let {
        Resultado: resultadoCliente,
        Mensaje: mensajeCliente,
        Cliente: clienteEnc,
      } = respuestaCliente;

      if (resultadoCliente === "S") {
        const respuestaPedido = await buscarPedidoActual(id);

        const {
          Resultado: resultadoPedido,
          Pedido,
        } = respuestaPedido;

        if (resultadoPedido === "S") {
          clienteEnc = {
            ...clienteEnc,
            datos: {
              ...clienteEnc.datos,
              PedidoActual: Pedido,
            },
          };
        }
      }

      respuesta = {
        Resultado: resultadoCliente,
        Mensaje: mensajeCliente,
        Cliente: clienteEnc,
      };

      resolve(respuesta);
    } catch (error) {
      respuesta = {
        ...respuesta,
        Resultado: "E",
        Mensaje: error.message,
      };
      resolve(respuesta);
    }
  });
};
